import {Component} from '@angular/core';
import {DynamicComponent} from "../../dynamic-component";

@Component({
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.css'],
})
export class GroupComponent extends DynamicComponent {

}
